import { MultiSelectCombobox } from "@cmde/shadcn";
import { useMemo } from "react";

export interface LookupOption {
  id: string;
  name: string;
}

export function LookupMultiSelect({
  options,
  value,
  onChange,
  isLoading,
  placeholder,
  searchPlaceholder,
  emptyString,
  disabled,
}: {
  options: LookupOption[];
  value: string[];
  onChange: (value: string[]) => void;
  isLoading?: boolean;
  placeholder?: string;
  searchPlaceholder?: string;
  emptyString?: string;
  disabled?: boolean;
}) {
  const optionsById = useMemo(() => new Map(options.map((option) => [option.id, option])), [options]);

  const selected = useMemo(
    () => value.map((id) => optionsById.get(id) ?? { id, name: id }),
    [optionsById, value],
  );

  const data = useMemo(() => {
    const merged = new Map(optionsById);
    for (const item of selected) {
      if (!merged.has(item.id)) {
        merged.set(item.id, item);
      }
    }
    return [...merged.values()];
  }, [optionsById, selected]);

  return (
    <MultiSelectCombobox
      data={data}
      value={selected}
      onChange={(items) => onChange(items.map((item) => item.id))}
      by="id"
      searchBy="name"
      isLoading={isLoading}
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      emptyString={emptyString}
      className={disabled ? "pointer-events-none opacity-50" : "w-full"}
      contentAlign="start"
      contentAlignClassName="w-[var(--radix-popover-trigger-width)] min-w-[var(--radix-popover-trigger-width)]"
    />
  );
}
